import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { logoutAdmin } from '../../reducers/AdminAuth';
import { APP_LOGO, MENU_LABELS, ROUTES } from '../../config/constants';
import { isSuperAdminArbitrator } from '../../utils/arbitratorScope';

const ECOSYSTEM_LINKS = [
  { label: 'Mindhosts', href: '#' },
  { label: 'LecturersClub', href: '#' },
  { label: 'Indlearn', href: '#' },
  { label: 'MindhostsPlus', href: '#' },
  { label: 'ITArmy', href: '#' },
  { label: 'Indversity', href: '#' },
  { label: 'Englishvoice', href: '#' },
];

class Header extends Component {
  state = { userMenuOpen: false };

  logout = () => {
    this.props.logoutAdmin();
  };

  render() {
    const { name, username, organization_name, group_name } = this.props;
    const displayName = name || 'Arbitrator';
    const displayEmail = username || 'arbitrator@iaept.com';
    const orgName = organization_name || 'Indgigs';
    const isChapterArbitrator = !isSuperAdminArbitrator(this.props);
    const welcomeSub = isChapterArbitrator && group_name
      ? `Managing GIG TEAM: ${group_name}`
      : 'Manage members, GIG TEAMS, events, and community resources.';

    return (
      <div className="nk-header nk-header-fixed iaept-top-header">
        <div className="iaept-header-bar">
          <div className="iaept-header-col iaept-header-col-left">
            <div className="iaept-header-welcome">
              <h5 className="iaept-welcome-title">Welcome to Indgigs</h5>
              <p className="iaept-welcome-sub">{welcomeSub}</p>
            </div>
          </div>

          <div className="iaept-header-col iaept-header-col-center d-none d-xl-flex">
            <div className="iaept-header-brand-row">
              <img src={APP_LOGO} alt="Indgigs" className="iaept-header-logo" />
              <span className="iaept-header-org">{orgName}</span>
            </div>
            <div className="iaept-header-ecosystem-row">
              {ECOSYSTEM_LINKS.map((link, i) => (
                <Fragment key={link.label}>
                  {i > 0 && <span className="iaept-eco-sep" aria-hidden="true">|</span>}
                  <a href={link.href} className="iaept-eco-link">{link.label}</a>
                </Fragment>
              ))}
            </div>
          </div>

          <div className="iaept-header-col iaept-header-col-right">
            <div className="iaept-header-user-wrap">
              <button
                type="button"
                className="iaept-header-user"
                onClick={() => this.setState((s) => ({ userMenuOpen: !s.userMenuOpen }))}
              >
                <div className="iaept-header-avatar">
                  <img src={APP_LOGO} alt={displayName} />
                </div>
                <div className="iaept-header-user-info d-none d-md-block">
                  <span className="iaept-user-name">{displayName}</span>
                  <span className="iaept-user-email">{displayEmail}</span>
                </div>
                <em className="icon ni ni-chevron-down iaept-user-caret d-none d-md-block" />
              </button>

              {this.state.userMenuOpen && (
                <div className="iaept-user-dropdown">
                  <Link to={ROUTES.SETTINGS} className="iaept-user-dropdown-item" onClick={() => this.setState({ userMenuOpen: false })}>
                    <em className="icon ni ni-user-alt" />
                    {MENU_LABELS.VIEW_PROFILE}
                  </Link>
                  <button type="button" className="iaept-user-dropdown-item" onClick={() => this.logout()}>
                    <em className="icon ni ni-signout" />
                    Sign out
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  name: state.AdminAuth.name,
  username: state.AdminAuth.username,
  organization_name: state.AdminAuth.organization_name,
  role_type: state.AdminAuth.role_type,
  group_id: state.AdminAuth.group_id,
  group_name: state.AdminAuth.group_name,
  privileges: state.AdminAuth.privileges,
  loggedIn: state.AdminAuth.loggedIn,
});

const mapDispatchToProps = (dispatch) => ({
  logoutAdmin: () => logoutAdmin(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
